import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { api } from "@/lib/api";

const ServerStatusContext = createContext({ loading: true });

export function ServerStatusProvider({ children }) {
  const [status, setStatus] = useState({ loading: true });
  const [cameOnline, setCameOnline] = useState(false);
  const prevOnline = useRef(undefined);

  useEffect(() => {
    let alive = true;
    const apply = (next) => {
      if (!alive) return;
      if (prevOnline.current === false && next.online === true) setCameOnline(true);
      if (next.online === false) setCameOnline(false);
      prevOnline.current = next.online;
      setStatus({ ...next, loading: false });
    };
    const load = () => api.get("/server/status").then(({ data }) => apply(data)).catch(() => apply({ online: null, error: "unavailable" }));
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const dismissOnline = useCallback(() => setCameOnline(false), []);
  const value = useMemo(() => ({ ...status, cameOnline, dismissOnline }), [status, cameOnline, dismissOnline]);

  return <ServerStatusContext.Provider value={value}>{children}</ServerStatusContext.Provider>;
}

export const useServerStatus = () => useContext(ServerStatusContext);
